import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { MainComponent } from './components/pages/anwendung/main/main.component';
import { PageNotFoundComponent } from './components/pages/page-not-found/page-not-found.component';
import { GlobalConstantsRouting } from 'globales-projekt-angular';
import { HilfeComponent } from './components/pages/navbar-pages/hilfe/hilfe.component';
import { ErgebnisseComponent } from './components/pages/anwendung/ergebnisse/ergebnisse.component';
import { ConstantsRouting } from './immutable/constants-routing';
import { BegriffserlaeuterungenBaukostComponent } from './components/pages/navbar-pages/begriffserlaeuterungen-baukost/begriffserlaeuterungen-baukost.component';
import { UeberBaukostComponent } from './components/pages/navbar-pages/ueber-baukost/ueber-baukost.component';

const routes: Routes = [
  { path: '', redirectTo: GlobalConstantsRouting.REDIRECT_TO, pathMatch: GlobalConstantsRouting.PATH_MATCH },
  { path: GlobalConstantsRouting.MAIN, component: MainComponent },
  { path: GlobalConstantsRouting.ERGEBNISSE, component: ErgebnisseComponent },
  { path: GlobalConstantsRouting.HILFE, component: HilfeComponent },
  { path: ConstantsRouting.BEGRIFFSERLAEUTERUNGEN_BAUKOST, component: BegriffserlaeuterungenBaukostComponent },
  { path: ConstantsRouting.UEBER_BAUKOST, component: UeberBaukostComponent },
  { path: GlobalConstantsRouting.PAGE_NOT_FOUND, component: PageNotFoundComponent },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule {}
 